import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M3 3.75a.75.75 0 01.75.75v14.25H21a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75v-15A.75.75 0 013 3.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M21.564 8.506a.75.75 0 01-.07 1.058l-6 5.25a.75.75 0 01-.944.036l-5.514-4.135-5.542 4.85a.75.75 0 11-.988-1.13l6-5.25a.75.75 0 01.944-.035l5.514 4.135 5.542-4.85a.75.75 0 011.058.071z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
